import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as sisMapActions from "store/modules/rds_sisMap";
import $ from "jquery";
import { LoadingContext } from "../../loadingContext";

import "./safety.scss";

import { IoIosArrowForward } from "react-icons/io";
import { MdClose } from "react-icons/md";
import { BsPlus, BsDash } from "react-icons/bs";
import { AiOutlineUnorderedList } from "react-icons/ai";

import SisSelect from "store/sis/component/SisSelect";
import SisOverlay from "store/sis/SisOverlay";

class Safety extends Component {
	static contextType = LoadingContext;
	state = {
		title: "안전",
		activeItem: "",
		lstEmd: [],
		lstYmd: [],
		lstGb: [],
		lstMt: [],
		lstDay: [],
		lstTime: [],
		source:"",
	};

	openSearchWrap = (evt) => {
		$("#safetyWrap .itemsWrap").hide();
		$("#safetyWrap .searchWrap").show();
		$("#safetyWrap .close").show();
		$(".source").show();
		$("#safetyWrap .searchWrap").css("top","60px");		

		const id = $(evt.target).closest(".item").attr("id");
		const title = $(evt.target).closest(".item").find("span").text();
		let source = "";	

		if(id=="security"){
			this.getYmd("police_info");		
			this.getGb(id);
			source = "경찰청 생활안전계";
		}else if(id=="cctv"){
			this.getYmd("cctv_info");		
			this.getGb(id);
			source = "사회재난과";
		}else if(id=="crime"){
			this.getYmd("crime_occur");
			this.getGb(id);
		}else if(id=="defense"){
			this.getYmd("defense_facility");
			source = "전남광주통합특별시 안전정책관";
		}else if(id=="wtsupp"){
			this.getYmd("wtsupp_facility");
			source = "전남광주통합특별시 안전정책관";
		}else if(id=="steep"){
			this.getYmd("steep_slope");
			source = "재난안전포털";
		}
		this.setState({
			activeItem: id,
			title,
			source,
		});
	};

	closeSearchWrap = () => {
		$("#safetyWrap .searchWrap").hide();
		$("#safetyWrap .itemsWrap").show();
		$("#apartModal .close").click();
		$(".tabWrap .tab.active .searchWrap .listWrap").remove();
		$("#safetyWrap .close").hide();
		$(".source").hide();
		$("#safetyWrap .searchWrap").css("top","");

		this.setState({
			activeItem: "",
			title: "안전",
		});
	};

	// 읍면동 불러오기
	getEmd = (value) => {
		let lstEmd = [];

		$.ajax({
			url: "/map/getEmd",
			type: "post",
			data: {
				value,
			},
			success: (res) => {
				lstEmd = res;

				this.setState({
					lstEmd: [{ emdCd: "0", emdNm: "=== 전체 ===" }, ...lstEmd],
				});
			},
		});
	};

	//년도 가져오기
	getYmd = (value) => {
		let lstYmd = [];

		$.ajax({
			url: "/map/getYmd",
			type: "post",
			data: {
				value,
			},
			success: (res) => {
				
				lstYmd = res;

				this.setState({
					lstYmd: [...lstYmd],
				});
			},
		});
	};

	//그룹 가져오기
	getGb = (id) => {
		let lstGb = [];
		let lstMt= [];
		let lstDay= [];
		let lstTime= [];

		if(id==="security"){
			lstGb = [
				{group:'경찰서',name:'경찰서'}, 
				{group:'지구대', name:'지구대'},
				{group:'파출소', name:'파출소'},
				{group:'치안센터', name:'치안센터'},
				{group:'기동순찰대', name:'기동순찰대'}
			];
		}else if(id==="cctv"){
			lstGb = [
				{group:'CTVGNCTV01',name:'방범대'}, 
				{group:'CTVGNCTV02', name:'어린이보호'},
				{group:'CTVGNCTV03', name:'공원'},
				{group:'CTVGNCTV04', name:'재난재해'},
				{group:'CTVGNCTV05', name:'차량번호인식'},
				{group:'CTVGNCTV06', name:'초등학교'},
				{group:'CTVGNCTV07', name:'하천감시'},
				{group:'CTVGNCTV08', name:'산불감시'},
				{group:'CTVGNCTV09', name:'도시교통정보'},
				{group:'CTVGNCTV10', name:'하천감시(환경)'},
				{group:'CTVGNCTV11', name:'주정차단속용'}
			];
		}else if(id==="crime"){
			lstGb = [
				{group:'CRMGNCRM01',name:'강간·강제추행'}, 
				{group:'CRMGNCRM02', name:'강도'},
				{group:'CRMGNCRM03', name:'살인'},
				{group:'CRMGNCRM04', name:'절도'},
				{group:'CRMGNCRM05', name:'폭력'}
			];

			lstMt = [
				{group:'01',name:'1월'}, 
				{group:'02', name:'2월'},
				{group:'03', name:'3월'},
				{group:'04', name:'4월'},
				{group:'05', name:'5월'},
				{group:'06',name:'6월'}, 
				{group:'07', name:'7월'},
				{group:'08', name:'8월'},
				{group:'09', name:'9월'},
				{group:'10', name:'10월'},
				{group:'11', name:'11월'},
				{group:'12', name:'12월'}
			];
			this.setState({
				lstMt: [{ group: "0", name: "=== 전체 ===" }, ...lstMt],
			});	
			
			lstDay = [
				{group:'1',name:'일요일'}, 
				{group:'2', name:'월요일'},
				{group:'3', name:'화요일'},
				{group:'4', name:'수요일'},
				{group:'5', name:'목요일'},
				{group:'6',name:'금요일'}, 
				{group:'7', name:'토요일'}
			];
			this.setState({
				lstDay: [{ group: "0", name: "=== 전체 ===" }, ...lstDay],
			});
			
			lstTime = [
				{group:'0',name:'00시'}, 
				{group:'1',name:'01시'}, 
				{group:'2',name:'02시'},
				{group:'3',name:'03시'},
				{group:'4',name:'04시'},
				{group:'5',name:'05시'},
				{group:'6',name:'06시'},
				{group:'7',name:'07시'},
				{group:'8',name:'08시'},
				{group:'9',name:'09시'},
				{group:'10',name:'10시'},
				{group:'11',name:'11시'},
				{group:'12',name:'12시'},
				{group:'13',name:'13시'},
				{group:'14',name:'14시'}, 
				{group:'15',name:'15시'},
				{group:'16',name:'16시'},
				{group:'17',name:'17시'},
				{group:'18',name:'18시'},
				{group:'19',name:'19시'},
				{group:'20',name:'20시'},
				{group:'21',name:'21시'},
				{group:'22',name:'22시'},
				{group:'23',name:'23시'}
			];
			this.setState({
				lstTime: [{ group: "All", name: "=== 전체 ===" }, ...lstTime],
			});					
		}
		this.setState({
			lstGb: [{ group: "0", name: "=== 전체 ===" }, ...lstGb],
		});		
	};

	// 오버레이 클릭 이벤트(모달)
	_overlayClickEvent = (ele, id, activeItem, noProps = false,mapZoom = false) => {
		const { actions, layout, sis } = this.props;
		let overlayElement;
		let col;

		if (activeItem === "crime") {
			overlayElement = (
				<>
					<div
						className="sisOverlayClose"
						onClick={() => {
							$(`#${id}`).remove();
						}}
					>
						<MdClose size="25px" />
					</div>

					<span className="safetyTitle">{ele.crimeName}</span>
					<span className="safetyAddress">{ele.crimeAddr}</span>
					<table>
						<caption>범죄</caption>
						<tbody>
							<tr>
								<th>발생월</th>
								<td>{ele.crimeYm ? ele.crimeYm : "-"}</td>
							</tr>
							<tr>
								<th>발생시간</th>
								<td>{ele.crimeTime ? ele.crimeTime : "-"}</td>
							</tr>
							<tr>
								<th>범죄유형</th>
								<td>{ele.crimeName ? ele.crimeName : "-"}</td>
							</tr>
						</tbody>
					</table>
				</>
			);
		} else if (activeItem === "security") {
			let parkGb = ele.policeGbn;
				let name = "";
				let classNm = "";

				switch (parkGb) {
					case "경찰서":
						name = "경찰서";
						classNm = "tag police";
						break;
					case "지구대":
						name = "지구대";
						classNm = "tag police2";
						break;
					case "파출소":
						name = "파출소";
						classNm = "tag police3";
						break;
					case "치안센터":
						name = "치안";
						classNm = "tag police4";
						break;
					case "기동순찰대":
						name = "기동";
						classNm = "tag police5";
						break;
				}
			overlayElement = (
				<>
					<div
						className="sisOverlayClose"
						onClick={() => {
							$(`#${id}`).remove();
						}}
					>
						<MdClose size="25px" />
					</div>

					<span className="safetyTitle">{ele.policeName}</span>
					<span className={classNm}>{name}</span>
					{/*<span>전화번호 : {ele.tel}</span>*/}
				</>
			);
		} else if (activeItem === "cctv") {
			overlayElement = (
				<>
					<div
						className="sisOverlayClose"
						onClick={() => {
							$(`#${id}`).remove();
						}}
					>
						<MdClose size="25px" />
					</div>

					<span className="safetyTitle">{ele.cctvName}</span>
					<span className="safetyAddress">주소 : {ele.address}</span>
					<table>
						<caption>CCTV 위치정보</caption>
						<tbody>
							<tr>
								<th>상제주소</th>
								<td>{ele.addrDesc ? ele.addrDesc : "-"}</td>
							</tr>
							<tr>
								<th>CCTV개수</th>
								<td>{ele.cctvCount ? ele.cctvCount : "-"}</td>
							</tr>
							<tr>
								<th>설치유형</th>
								<td>{ele.installAim ? ele.installAim : "-"}</td>
							</tr>
						</tbody>
					</table>
					
				</>
			);
		} else if (activeItem === "defense"){
			overlayElement = (
				<>
					<div
						className="sisOverlayClose"
						onClick={() => {
							$(`#${id}`).remove();
						}}
					>
						<MdClose size="25px" />
					</div>

					<span className="safetyTitle">{ele.detailStat}</span>
					<span className="safetyAddress">{ele.roadAddress ? ele.roadAddress : ele.address}</span>

					<table>
						<caption>민방위 주민대피시설</caption>
						<tbody>
						<tr>
							<th>대피가능인원</th>
							<td>{ele.evacPerson  != null && !isNaN(Number(ele.evacPerson)) ? Number(ele.evacPerson).toLocaleString() : "-"}</td>
						</tr>
						</tbody>
					</table>
				</>
			);
		} else if (activeItem === "wtsupp"){
			overlayElement = (
				<>
					<div
						className="sisOverlayClose"
						onClick={() => {
							$(`#${id}`).remove();
						}}
					>
						<MdClose size="25px" />
					</div>

					<span className="safetyTitle">{ele.nane}</span>
					<span className="safetyAddress">{ele.roadAddress ? ele.roadAddress : ele.address}</span>

					<table>
						<caption>급경사지</caption>
						<tbody>
						<tr>
							<th>평시활용유형</th>
							<td>{ele.purpose ? ele.purpose : "-"}</td>
						</tr>
						<tr>
							<th>대피가능인원</th>
							<td>{ele.suppCapacity  != null && !isNaN(Number(ele.suppCapacity)) ? Number(ele.suppCapacity).toLocaleString() : "-"}</td>
						</tr>
						</tbody>
					</table>
				</>
			);
		} else if (activeItem === "steep"){
			overlayElement = (
				<>
					<div
						className="sisOverlayClose"
						onClick={() => {
							$(`#${id}`).remove();
						}}
					>
						<MdClose size="25px" />
					</div>

					<span className="safetyTitle">{ele.slopeName ? ele.slopeName : "-"}</span>
					<span className="safetyAddress">{ele.address ? ele.address : "-"}</span>

					<table>
						<caption>대피가능인원</caption>
						<tbody>
						<tr>
							<th>관리기관</th>
							<td>{ele.slopeMng ? ele.slopeMng : "-"}</td>
						</tr>
						</tbody>
					</table>
				</>
			);
		}

		let overlay = sis.sisMap.map.getOverlayById("overlaySelector");
		sis.sisMap.map.removeOverlay(overlay);

		actions.addResultOverlay({
			element: overlayElement,
			data: ele,
			id,
			className: "removeOverlayWrap",
			isTop: true,
			noProps,
			mapZoom,
		});
	};

	// 오버레이 클릭 이벤트(겹치는거 확인)
	overlayClickEvent = (ele, evt, overlay) => {
		const { actions, layout, sis } = this.props;

		let col = "";
		const activeItem = $(evt.target).closest(".sisOverlayWrap").find("span:first").attr("class");
		const id = `safty_${activeItem}_removeOverlay`;
		$(`#${id}`).remove();

		let existOverlay = sis.sisMap.map.getOverlayById(id);
		if (existOverlay) sis.sisMap.map.removeOverlay(existOverlay);

		if (activeItem === "crime") col = "crimeName";
		else if (activeItem === "security") col = "policeName";
		else if (activeItem === "cctv") col = "cctvName";
		else if (activeItem === "shelter") col = "facilityName";
		else if (activeItem === "defense") col = "detailStat";
		else if (activeItem === "wtsupp") col = "nane";
		else if (activeItem === "steep") col = "steepName";

		const arrOverlays = [];
		const pos = overlay.getPosition();
		const interval = 1;
		let xInterval = 0;
		let yInterval = 0;
		const overlays = sis.sisMap.map.getOverlays().getArray();

		// console.log("dd");
		$.each(overlays, (idx, item) => {
			let targetPos = item.getPosition();

			if (targetPos) {
				targetPos = targetPos;

				xInterval = Math.abs(pos[0] - targetPos[0]);
				yInterval = Math.abs(pos[1] - targetPos[1]);

				if (xInterval <= interval && yInterval <= interval) {
					arrOverlays.push(item);
				}
			}
		});

		if (arrOverlays.length > 1) {
			
			// if (true) {
			// 오버레이 생성
			const overlayElement = document.createElement("div");
			document.body.appendChild(overlayElement);
			overlayElement.className = "overlaySelector";
			overlayElement.id = "overlaySelector";

			let overlay = sis.sisMap.map.getOverlayById("overlaySelector");

			if (overlay) sis.sisMap.map.removeOverlay(overlay);
			overlay = new SisOverlay(`#overlaySelector`, sis.sisMap.map, "bottom-center", [0, 0]);
			overlay.setPosition(pos);
			$(overlayElement).parent().css("z-index", 9999);

			arrOverlays.forEach((item) => {
				const props = item.getProperties();

				if (props[col]) {
					const element = document.createElement("div");
					element.innerText = props[col];
					$(overlayElement).append(element);

					$(element).on("click", () => {
					this._overlayClickEvent(props, id, activeItem, true);
					sis.sisMap.map.removeOverlay(overlay);
					});
				}

				// $(overlayElement).append(`<div>${props.buildNm}</div>`);
			});
			
		} else {
		this._overlayClickEvent(ele, id, activeItem);
		}

		return;
	};

	// 오버레이 생성
	createOverlay = (data, id) => {
		const { actions } = this.props;
		const { activeItem } = this.state;

		$(".tabWrap .tab.active .searchWrap .listWrap").remove();
		$(".tabWrap .tab.active .searchWrap").append("<div class='listWrap'><span class='cnt'>검색결과 <a>" + data.length.toLocaleString() + "</a>건</span></div>");

		data.forEach((ele, idx) => {
			let overlayElement;

			if (activeItem === "crime") {
				overlayElement = (
					<>
						<span className={activeItem}>{ele.crimeName}</span>
					</>
				);
				//$(".tabWrap .tab.active .searchWrap .listWrap").append(`<span class=lst_${id}_${ele.gid}>${ele.crimeName}</span>`);
			} else if (activeItem === "security") {
				let parkGb = ele.policeGbn;
				let name = "";
				let classNm = "";

				switch (parkGb) {
					case "경찰서":
						name = "경찰서";
						classNm = "tag police";
						break;
					case "지구대":
						name = "지구대";
						classNm = "tag police2";
						break;
					case "파출소":
						name = "파출소";
						classNm = "tag police3";
						break;
					case "치안센터":
						name = "치안";
						classNm = "tag police4";
						break;
					case "기동순찰대":
						name = "기동";
						classNm = "tag police5";
						break;
				}
				overlayElement = (
					<>
						<span className={activeItem}>
							<span className={classNm} style={{marginRight:"3px"}}>{name}</span>
							{ele.policeName}
						</span>
					</>
				);
				//$(".tabWrap .tab.active .searchWrap .listWrap").append(`<span class=lst_${id}_${ele.gid}>${ele.policeName}</span>`);
			} else if (activeItem === "cctv") {
				overlayElement = (
					<>
						<span className={activeItem}>{ele.cctvName}</span>
					</>
				);
				//$(".tabWrap .tab.active .searchWrap .listWrap").append(`<span class=lst_${id}_${ele.gid}>${ele.cctvName}</span>`);
			}  else if (activeItem === "defense") {
				overlayElement = (
					<>
						<span className={activeItem}>{ele.detailStat}</span>
					</>
				);
				//$(".tabWrap .tab.active .searchWrap .listWrap").append(`<span class=lst_${id}_${ele.gid}>${ele.detailStat}</span>`);
			} else if (activeItem === "wtsupp") {
				overlayElement = (
					<>
						<span className={activeItem}>{ele.nane}</span>
					</>
				);
				//$(".tabWrap .tab.active .searchWrap .listWrap").append(`<span class=lst_${id}_${ele.gid}>${ele.nane}</span>`);
			} else if (activeItem === "steep") {
				overlayElement = (
					<>
						<span className={activeItem}>{ele.slopeName}</span>
					</>
				);
				//$(".tabWrap .tab.active .searchWrap .listWrap").append(`<span class=lst_${id}_${ele.gid}>${ele.slopeName}</span>`);
			}

			// $(`.lst_${id}_${ele.gid}`).on("click", () => {
			// 	$(`#${id}_${ele.gid}`)[0].click();

			// 	const feature = this.props.sis.sisLayer.createFeatureByWKT(ele.geom);
			// 	feature.getGeometry().transform("EPSG:5186", "EPSG:5181");
			// 	this.props.sis.sisMap.view.fit(feature.getGeometry().getExtent());
			// 	this.props.sis.sisMap.view.setZoom(8);
			// });
			let minZoom,maxZoom;
			if(activeItem==="cctv"){
				minZoom=8;
				maxZoom=10;
			}else{
				minZoom=6;
				maxZoom=10;
			}

			actions.addResultOverlay({
				element: overlayElement,
				data: ele,
				id: `${id}_${ele.gid}`,
				className: "safetyOverlayWrap",
				onClick: this.overlayClickEvent,
				minZoom: minZoom,
				maxZoom: maxZoom,
			});
		});

		// 오버레이 클릭 이벤트
		data.forEach((ele, idx) => {
			let overlayElement;
			if (activeItem==="security") {
				//$(".tabWrap .tab.active .searchWrap .listWrap").append(`<span class=lst_${id}_${ele.gid}>${ele.equipNm}</span>`);

				$(".tabWrap .tab.active .searchWrap .listWrap").append(
					`<span class="lst_${id}_${ele.gid}" 
						data-ele='${JSON.stringify(ele).replace(/'/g, "&apos;")}' 
						data-id='${id}' 
						data-active-item='${activeItem}'>
					${ele.policeName}
					</span>`
				);
			} else if (activeItem==="cctv"){
				$(".tabWrap .tab.active .searchWrap .listWrap").append(
					`<span class="lst_${id}_${ele.gid}" 
						data-ele='${JSON.stringify(ele).replace(/'/g, "&apos;")}' 
						data-id='${id}' 
						data-active-item='${activeItem}'>
					${ele.cctvName}
					</span>`
				);
			}	else if (activeItem==="crime"){
				$(".tabWrap .tab.active .searchWrap .listWrap").append(
					`<span class="lst_${id}_${ele.gid}" 
						data-ele='${JSON.stringify(ele).replace(/'/g, "&apos;")}' 
						data-id='${id}' 
						data-active-item='${activeItem}'>
					${ele.crimeName}
					</span>`
				);
			}else if (activeItem==="defense"){
				$(".tabWrap .tab.active .searchWrap .listWrap").append(
					`<span class="lst_${id}_${ele.gid}" 
						data-ele='${JSON.stringify(ele).replace(/'/g, "&apos;")}' 
						data-id='${id}' 
						data-active-item='${activeItem}'>
					${ele.detailStat}
					</span>`
				);
			}else if (activeItem==="wtsupp"){
				$(".tabWrap .tab.active .searchWrap .listWrap").append(
					`<span class="lst_${id}_${ele.gid}" 
						data-ele='${JSON.stringify(ele).replace(/'/g, "&apos;")}' 
						data-id='${id}' 
						data-active-item='${activeItem}'>
					${ele.nane}
					</span>`
				);
			}else if (activeItem==="steep"){
				$(".tabWrap .tab.active .searchWrap .listWrap").append(
					`<span class="lst_${id}_${ele.gid}" 
						data-ele='${JSON.stringify(ele).replace(/'/g, "&apos;")}' 
						data-id='${id}' 
						data-active-item='${activeItem}'>
					${ele.slopeName}
					</span>`
				);
			}

			
		});

		$(".tabWrap .tab.active .searchWrap .listWrap").on("click", "span", (event) => {
			const target = $(event.currentTarget);
		
			const eleAttr = target.attr("data-ele");
			const id = target.attr("data-id")+"_removeOverlay";
			const activeItem = target.attr("data-active-item");
		
			if (!eleAttr) {
				console.error("data-ele 값이 없습니다.");
				return;
			}
		
			try {
				// JSON.parse() 한 번만 실행
				const ele = JSON.parse(eleAttr);
				
				// `this._overlayClickEvent()`를 호출하도록 변경 (화살표 함수 덕분에 this 유지됨)
				if (typeof this._overlayClickEvent === "function") {
					const mapZoom = true;
					const noProps = false;
					this._overlayClickEvent(ele, id, activeItem,noProps,mapZoom);
				} else {
					console.error("_overlayClickEvent 함수가 존재하지 않습니다.");
				}
			} catch (error) {
				console.error("JSON 파싱 오류:", error);
			}
		});
		if(activeItem === "security"||activeItem === "cctv"){
			$(".tabWrap .tab.active .searchWrap .listWrap").css("top","270px");
		}else if(activeItem === "defense" || activeItem === "wtsupp" || activeItem === "steep"){
			$(".tabWrap .tab.active .searchWrap .listWrap").css("top","225px");
		}else if(activeItem === "crime" ){
			$(".tabWrap .tab.active .searchWrap .listWrap").css("top","420px");
		}
	};

	// 트리 범례 생성
	createTreeLegend = (props) => {
		if(props.id==="safety_crime"){
			return (
				<>
					<div className="legendWrap">
						<div
							className="legendToggle"
							onClick={(e) => {
								$(e.target).closest(".legendToggle").find(".legendVisible").toggle();
								$(e.target).closest(".legendWrap").find(".legendContents").slideToggle("fast");
							}}
						>
							<BsPlus className="legendVisible hide" size="18px" />
							<BsDash className="legendVisible" size="18px" />
						</div>
	
						<span className="legendTitle">
							<AiOutlineUnorderedList size="15px" />
							범례
						</span>
	
						<div className="legendContents">
							<span style={{ display: "inline-block" }} className="tag crime">
								강간
							</span>
							<span style={{ display: "inline-block", marginRight: "50px" }} className="text">
								강간·강제추행
							</span>
	
							<span style={{ display: "inline-block" }} className="tag crime2">
								강도
							</span>
							<span style={{ display: "inline-block", marginRight: "20px" }} className="text">
								강도
							</span>

							<span style={{ display: "inline-block" }} className="tag crime3">
								살인
							</span>
							<span style={{ display: "inline-block" , marginRight: "100px"}} className="text">
								살인
							</span>

							<span style={{ display: "inline-block" }} className="tag crime4">
								절도
							</span>
							<span style={{ display: "inline-block", marginRight: "22px" }} className="text">
								절도
							</span>

							<span style={{ display: "inline-block" }} className="tag crime5">
								폭력
							</span>
							<span style={{ display: "inline-block" }} className="text">
								폭력
							</span>
						</div>
					</div>
				</>
			);
		}if(props.id==="safety_cctv"){
			return (
				<>
					<div className="legendWrap">
						<div
							className="legendToggle"
							onClick={(e) => {
								$(e.target).closest(".legendToggle").find(".legendVisible").toggle();
								$(e.target).closest(".legendWrap").find(".legendContents").slideToggle("fast");
							}}
						>
							<BsPlus className="legendVisible hide" size="18px" />
							<BsDash className="legendVisible" size="18px" />
						</div>
	
						<span className="legendTitle">
							<AiOutlineUnorderedList size="15px" />
							범례
						</span>
	
						<div className="legendContents">
							<span style={{ display: "inline-block" }} className="tag cctv">
								방범대
							</span>
							<span style={{ display: "inline-block", marginRight: "50px" }} className="text">
								방범대
							</span>
	
							<span style={{ display: "inline-block" }} className="tag cctv2">
								어린이
							</span>
							<span style={{ display: "inline-block" ,marginRight: "20px"}} className="text">
								어린이보호
							</span>

							<span style={{ display: "inline-block" }} className="tag cctv3">
								공원
							</span>
							<span style={{ display: "inline-block", marginRight: "74px"  }} className="text">
								공원
							</span>

							<span style={{ display: "inline-block" }} className="tag cctv4">
								재난
							</span>
							<span style={{ display: "inline-block" ,marginRight: "40px"}} className="text">
								재난재해
							</span>

							<span style={{ display: "inline-block" }} className="tag cctv5">
								번호
							</span>
							<span style={{ display: "inline-block", marginRight: "30px"  }} className="text">
								차량번호인식
							</span>

							<span style={{ display: "inline-block" }} className="tag cctv6">
								초등
							</span>
							<span style={{ display: "inline-block" , marginRight: "40px" }} className="text">
								초등학교
							</span>

							<span style={{ display: "inline-block" }} className="tag cctv7">
								하천
							</span>
							<span style={{ display: "inline-block", marginRight: "50px" }} className="text">
								하천감시
							</span>

							<span style={{ display: "inline-block" }} className="tag cctv8">
								산불
							</span>
							<span style={{ display: "inline-block", marginRight: "40px"  }} className="text">
								산불감시
							</span>

							<span style={{ display: "inline-block" }} className="tag cctv9">
								교통
							</span>
							<span style={{ display: "inline-block", marginRight: "30px"  }} className="text">
								도시교통정보
							</span>

							<span style={{ display: "inline-block" }} className="tag cctv10">
								환경
							</span>
							<span style={{ display: "inline-block", marginRight: "20px"  }} className="text">
								하천감시(환경)
							</span>

							<span style={{ display: "inline-block" }} className="tag cctv11">
								주정차
							</span>
							<span style={{ display: "inline-block" }} className="text">
								주정차단속용
							</span>
						</div>
					</div>
				</>
			);
		} else{
			return (
				<>
					<div className="legendWrap">
						<div
							className="legendToggle"
							onClick={(e) => {
								$(e.target).closest(".legendToggle").find(".legendVisible").toggle();
								$(e.target).closest(".legendWrap").find(".legendContents").slideToggle("fast");
							}}
						>
							<BsPlus className="legendVisible hide" size="18px" />
							<BsDash className="legendVisible" size="18px" />
						</div>
	
						<span className="legendTitle">
							<AiOutlineUnorderedList size="15px" />
							범례
						</span>
	
						<div className="legendContents">
							<span style={{ display: "inline-block", marginRight: "0px"  }} className="tag police">
								경찰서
							</span>
							<span style={{ display: "inline-block", marginRight: "50px" }} className="text">
								경찰서
							</span>
							<span style={{ display: "inline-block" , marginRight: "0px" }} className="tag police2">
								지구대
							</span>
							<span style={{ display: "inline-block", marginRight: "50px" }} className="text">
								지구대
							</span>
	
							<span style={{ display: "inline-block" , marginRight: "0px" }} className="tag police3">
								파출소
							</span>
							<span style={{ display: "inline-block" , marginRight: "50px" }} className="text">
								파출소
							</span>

							<span style={{ display: "inline-block", marginRight: "0px"  }} className="tag police4">
								치안
							</span>
							<span style={{ display: "inline-block"  , marginRight: "40px"}} className="text">
								치안센터
							</span>
							<span style={{ display: "inline-block", marginRight: "0px"  }} className="tag police5">
								기동
							</span>
							<span style={{ display: "inline-block" }} className="text">
								기동순찰대
							</span>
						</div>
					</div>
				</>
			);
		};
	}
		

	// 검색
	search = async (evt, id) => {
		const { setLoading } = this.context; // ✅ context에서 setLoading 가져오기
    	setLoading(true);
		$(".layerOpen").css("display","block");
		const { activeItem } = this.state;
		const { actions, sis } = this.props;

		let stdYmd = document.querySelector("select#selectLivingStdYmd");
		// stdYmd 값을 select에서 직접 가져오기
		if (stdYmd) {
			stdYmd = stdYmd.value;
		} else {
			stdYmd = null;  // 요소가 없으면 기본값 null 설정
		}

		// 기준년도 값이 없으면 1초 대기 후 실행
		const waitForStdYmd = () => {
			return new Promise(resolve => {
			  if (!stdYmd || stdYmd.trim() === "") {
				//console.log("기준년도 값이 없습니다. 1초 대기 중...");
				// 1초 대기 후, resolve를 호출하여 대기 끝냄
				setTimeout(() => {
				  resolve(); // Promise를 해결하여 대기 종료
				}, 1000);
			  } else {
				//console.log("기준년도 값이 있습니다.");
				resolve(); // 바로 resolve하여 대기 없이 진행
			  }
			});
		  };
		
		  // 비동기적으로 처리할 함수
		  await waitForStdYmd(); // 기준년도 값이 없으면 1초 기다리기

		let title = "";
		let data = [];
		//let stdYmd = "";
		let guBun = "0";
		let params = {};
		const activeItems = ["security", "cctv", "defense", "wtsupp", "steep", "crime"];
		if(activeItems.includes(activeItem)){
			stdYmd = $("select#selectSafetyStdYmd").val() || $("select#selectSafetyStdYmd option:first").val() || "0";
			guBun = $("select#selectSafetyGb").val() || $("select#selectSafetyGb option:first").val() || "0";
		}
		if(guBun==null){
			guBun = "0";
		}

		if(activeItem==="crime"){
			let month,day,time = "0";
			month = $("select#selectSafetyMonth").val();
			day = $("select#selectSafetyDay").val();
			time = $("select#selectSafetyTime").val();

			if(month==null) month = "0";
			if(day==null) day = "0";
			if(time==null) time = "All";

			params.sggCode = $("select#selectSafetySgg").val();
			params.emdCode = $("select#selectSafetyEmd").val();
			params.stdYmd = stdYmd;
			params.guBun = guBun;
			
			params.month = month;
			params.day = day;
			params.time = time;
		}else{
			params.sggCode = $("select#selectSafetySgg").val();
			params.emdCode = $("select#selectSafetyEmd").val();
			params.stdYmd = stdYmd;
			params.guBun = guBun;
		}
		//let params = {
		//	sggCode: $("select#selectSafetySgg").val(),
		//	emdCode: $("select#selectSafetyEmd").val(),
		//	stdYmd: stdYmd,
		//	guBun: guBun,
		//};
		let color = "#ff0000";
		let url = "";
		let legend = "";

		if (activeItem === "crime") {
			title = "범죄다발지역";
			color = "#d3362d";
			url = "/map/selectCrimeOccur";
			legend = this.createTreeLegend({
				data,
				id: `safety_${id}`,
			});
		} else if (activeItem === "security") {
			title = "치안시설";
			color = "#4374e0";
			url = "/map/selectSecurityFacilities";
			legend = this.createTreeLegend({
				data,
				id: `safety_${id}`,
			});
		} else if (activeItem === "cctv") {
			title = "cctv ";
			color = "#4374e0";
			url = "/map/selectCCTVInfo";
			legend = this.createTreeLegend({
				data,
				id: `safety_${id}`,
			})			
		} else if (activeItem === "defense") {
			if(stdYmd == null){
				params.stdYmd = '2022';
			}
			title = "민방위 주민대피시설";
			color = "#4374e0";
			url = "/map/selectDefenseInfo";
		} else if (activeItem === "wtsupp") {
			if(stdYmd == null){
				params.stdYmd = '2022';
			}
			title = "민방위 비상급수시설";
			color = "#4374e0";
			url = "/map/selectWtsuppInfo";
		} else if (activeItem === "steep") {
			if(stdYmd == null){
				params.stdYmd = '2023';
			}
			title = "급경사지";
			color = "#4374e0";
			url = "/map/selectSteepInfo";
		}

		$.ajax({
			url,
			type: "post",
			data: params,
			success: (res) => {
				data = res.items ? res.items : res;

				if (data.length === 0) {
					alert("검색결과가 없습니다.");
					setLoading(false);
					return;
				}

				if (res.wkt) {
					const feature = sis.sisLayer.createFeatureByWKT(res.wkt);
					feature.getGeometry().transform("EPSG:5186", "EPSG:5181");
					const extent = feature.getGeometry().getExtent();

					sis.sisMap.view.fit(extent);
				}

				const lyr = sis.sisLayer.getLayerById(`safety_${activeItem}`);

				if (lyr) {
					actions.deleteResult({
						id: `safety_${activeItem}`,
						refresh: true,
					});
				}

				// 트리아이템 생성
				actions.addResultItem({
					data: legend,
					id: `safety_${activeItem}`,
					title,
					closeEvent: actions.deleteResult,
					checkboxEvent: actions.resultCheckboxHandler,
				});



				// 레이어 생성
				actions.addResultLayer({
					data,
					id: `safety_${activeItem}`,
					type: "point",
					color,
					callback: () => {
						requestAnimationFrame(() => {
							setLoading(false); // ✅ UI 업데이트가 끝난 후 실행
						  });
					  }
				});

				// 오버레이 생성
				this.createOverlay(data, `safety_${activeItem}`);
			},
		});
	};

	render() {
		const { activeItem } = this.state;
		const { lstSgg, defaultSggCd } = this.props.sis;
		let searchElement;

		if(activeItem === "security"||activeItem === "cctv"){
			searchElement = (
				<>
					<div className="inputWrap">
						<span className="selectTitle">기준년도</span>
						<SisSelect
							id="selectSafetyStdYmd"
							ref={(ref) => (this.selectSafetyStdYmd = ref)}
							className="select"
							mapping={{
								key: "stdYmd",
								text: "stdName",
							}}
							items={this.state.lstYmd}
						/>
					</div>
					<div className="inputWrap">
						<span className="selectTitle">구명</span>
						<SisSelect
							id="selectSafetySgg"
							className="select"
							items={lstSgg}
							
							mapping={{
								key: "sggCd",
								text: "sggNm",
							}}
							onChange={this.getEmd}
							onLoaded={this.getEmd}
						/>
					</div>
					<div className="inputWrap">
						<span className="selectTitle">동명</span>
						<SisSelect
							id="selectSafetyEmd"
							className="select"
							mapping={{
								key: "emdCd",
								text: "emdNm",
							}}
							items={this.state.lstEmd}
						/>
					</div>
					<div className="inputWrap">
						<span className="selectTitle">시설유형</span>
						<SisSelect
							id="selectSafetyGb"							
							className="select"
							mapping={{
								key: "group",
								text: "name",
							}}
							items={this.state.lstGb}
						/>
					</div>

					<div className="btnWrap">
						<button id="btnSearch" onClick={(evt) => this.search(evt, activeItem)}>
							검색
						</button>
					</div>
				</>
			);
		}
		else if (activeItem === "defense" || activeItem === "wtsupp" || activeItem === "steep") {
			searchElement = (
				<>
					<div className="inputWrap">
						<span className="selectTitle">기준년도</span>
						<SisSelect
							id="selectSafetyStdYmd"
							ref={(ref) => (this.selectSafetyStdYmd = ref)}
							className="select"
							mapping={{
								key: "stdYmd",
								text: "stdName",
							}}

							items={this.state.lstYmd}
						/>
					</div>
					<div className="inputWrap">
						<span className="selectTitle">구명</span>
						<SisSelect
							id="selectSafetySgg"
							className="select"
							items={lstSgg}
							mapping={{
								key: "sggCd",
								text: "sggNm",
							}}
							onChange={this.getEmd}
							onLoaded={this.getEmd}
						/>
					</div>
					<div className="inputWrap">
						<span className="selectTitle">동명</span>
						<SisSelect
							id="selectSafetyEmd"
							className="select"
							mapping={{
								key: "emdCd",
								text: "emdNm",
							}}
							items={this.state.lstEmd}
						/>
					</div>

					<div className="btnWrap">
						<button id="btnSearch" onClick={(evt) => this.search(evt, activeItem)}>
							검색
						</button>
					</div>
				</>
			);
		}else if (activeItem === "crime") {
			searchElement = (
				<>
					<div className="inputWrap">
						<span className="selectTitle">기준년도</span>
						<SisSelect
							id="selectSafetyStdYmd"
							ref={(ref) => (this.selectSafetyStdYmd = ref)}
							className="select"
							mapping={{
								key: "stdYmd",
								text: "stdName",
							}}

							items={this.state.lstYmd}
						/>
					</div>
					<div className="inputWrap">
						<span className="selectTitle">구명</span>
						<SisSelect
							id="selectSafetySgg"
							className="select"
							items={lstSgg}
							
							mapping={{
								key: "sggCd",
								text: "sggNm",
							}}
							onChange={this.getEmd}
							onLoaded={this.getEmd}
						/>
					</div>
					<div className="inputWrap">
						<span className="selectTitle">동명</span>
						<SisSelect
							id="selectSafetyEmd"
							className="select"
							mapping={{
								key: "emdCd",
								text: "emdNm",
							}}
							items={this.state.lstEmd}
						/>
					</div>

					<div className="inputWrap">
						<span className="selectTitle">발생월</span>
						<SisSelect
							id="selectSafetyMonth"							
							className="select"
							mapping={{
								key: "group",
								text: "name",
							}}
							items={this.state.lstMt}					
						/>
					</div>

					<div className="inputWrap">
						<span className="selectTitle">발생요일</span>
						<SisSelect
							id="selectSafetyDay"							
							className="select"
							mapping={{
								key: "group",
								text: "name",
							}}
							items={this.state.lstDay}					
						/>
					</div>

					<div className="inputWrap">
						<span className="selectTitle">발생시간</span>
						<SisSelect
							id="selectSafetyTime"							
							className="select"
							mapping={{
								key: "group",
								text: "name",
							}}
							items={this.state.lstTime}					
						/>
					</div>

					<div className="inputWrap">
						<span className="selectTitle">범죄유형</span>
						<SisSelect
							id="selectSafetyGb"							
							className="select"
							mapping={{
								key: "group",
								text: "name",
							}}
							items={this.state.lstGb}
						/>
					</div>

					<div className="btnWrap">
						<button id="btnSearch" onClick={(evt) => this.search(evt, activeItem)}>
							검색
						</button>
					</div>
				</>
			);
		}
		else if (activeItem !== "") {
			searchElement = (
				<>
					<div className="inputWrap">
						<span className="selectTitle">구명</span>
						<SisSelect
							id="selectSafetySgg"
							className="select"
							items={lstSgg}
							
							mapping={{
								key: "sggCd",
								text: "sggNm",
							}}
							onChange={this.getEmd}
							onLoaded={this.getEmd}
						/>
					</div>
					<div className="inputWrap">
						<span className="selectTitle">동명</span>
						<SisSelect
							id="selectSafetyEmd"
							className="select"
							mapping={{
								key: "emdCd",
								text: "emdNm",
							}}
							items={this.state.lstEmd}
						/>
					</div>

					<div className="btnWrap">
						<button id="btnSearch" onClick={(evt) => this.search(evt, activeItem)}>
							검색
						</button>
					</div>
				</>
			);
		}

		return (
			<div id="safetyWrap" className="contentsWrap">
				<div className="title">
					<span>{this.state.title}</span>
					<div className="close" onClick={this.closeSearchWrap}>
						<MdClose />
					</div>
				</div>
				<div className="source" style={{display:"none"}}>
					<span className="origin_tit">출처</span>
					<span className="origin_stxt">{this.state.source}</span>
				</div>
				<div className="itemsWrap">
					<div id="security" className="item" onClick={this.openSearchWrap}>
						{/*<img className="logo" alt="치안시설" src="/sis/images/map/safety/icSecurity.png" />*/}
						<span>치안시설</span>
						<IoIosArrowForward className="arrow" />
					</div>

					{/*<div id="crime" className="item" onClick={this.openSearchWrap}>
						{/*<img className="logo" alt="범죄다발지역" src="/sis/images/map/safety/icFire.png" />
						<span>범죄다발지역</span>
						<IoIosArrowForward className="arrow" />
					</div>*/}

					<div id="cctv" className="item" onClick={this.openSearchWrap}>
						{/*<img className="logo" alt="CCTV 시설분석" src="/sis/images/map/safety/icShelter.png" />*/}
						<span>CCTV 시설분석</span>
						<IoIosArrowForward className="arrow" />
					</div>
					<div id="defense" className="item" onClick={this.openSearchWrap}>
						{/*<img className="logo" alt="민방위 주민대피시설" src="/sis/images/map/safety/icShelter.png" />*/}
						<span>민방위 주민대피시설</span>
						<IoIosArrowForward className="arrow" />
					</div>
					<div id="wtsupp" className="item" onClick={this.openSearchWrap}>
						{/*<img className="logo" alt="민방위 비상급수시설" src="/sis/images/map/safety/icShelter.png" />*/}
						<span>민방위 비상급수시설</span>
						<IoIosArrowForward className="arrow" />
					</div>
					<div id="steep" className="item" onClick={this.openSearchWrap}>
						{/*<img className="logo" alt="급경사지" src="/sis/images/map/safety/icShelter.png" />*/}
						<span>급경사지</span>
						<IoIosArrowForward className="arrow" />
					</div>
				</div>

				<div className="searchWrap">{searchElement}</div>
			</div>
		);
	}
}

export default connect(
	(state) => ({
		sis: state.sisMap,
	}),
	(dispatch) => ({
		actions: bindActionCreators(sisMapActions, dispatch),
	})
)(Safety);
